var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TheFooter',[_c('div',[_c('a',{attrs:{"href":"http://spctc.cr/telecentinel/","target":"_blank"}},[_vm._v("SPC Telecentinel")]),_c('span',{staticClass:"ml-1"},[_vm._v("© "+_vm._s(_vm.currentYear))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }